export const SET_ALL_LIKE_STATUSES = 'DS_FAVORITES/SET_ALL_LIKE_STATUSES';
export const SET_ALL_DISLIKE_REASONS = 'DS_FAVORITES/SET_ALL_DISLIKE_REASONS';

export const UPDATE_PRODUCT_LIKE_STATUSES = 'DS_FAVORITES/UPDATE_PRODUCT_LIKE_STATUSES';
export const UPDATE_PRODUCT_DISLIKE_REASONS = 'DS_FAVORITES/UPDATE_PRODUCT_DISLIKE_REASONS';

export const CLEAR_DISLIKE_REASONS = 'DS_FAVORITES/CLEAR_DISLIKE_REASONS';
